var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"min-height":"700px"}},[_c('el-empty',{attrs:{"description":"功能即将开放，敬请期待"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }